<script setup lang="ts">
import { PriceOverrideSort, SortOrder } from "@classes-service-types/index.ts";
import Button from "primevue/button";
import Menu from "primevue/menu";
import { computed, ref } from "vue";
import { useSortFilters } from "@/components/OperationsApp/composables/useSortFilters.ts";
import SimpleSortIcon from "@/components/shared/icons/SimpleSortIcon.vue";
import { PRICE_OVERRIDE_SORT_OPTIONS_MAP } from "./constants.ts";
import { filtersPresets } from "./styles.ts";

const props = withDefaults(defineProps<{}>(), {});

const { updateSortBy, sortBy, updateSortOrder, sortOrder } = useSortFilters();

const menu = ref();
const isExpanded = ref(false);
const items = ref([
  {
    items: [
      {
        label: PRICE_OVERRIDE_SORT_OPTIONS_MAP[PriceOverrideSort.Id],
        command: () => {
          updateSortBy(PriceOverrideSort.Id);
        },
      },
      {
        label: PRICE_OVERRIDE_SORT_OPTIONS_MAP[PriceOverrideSort.Amount],
        command: () => {
          updateSortBy(PriceOverrideSort.Amount);
        },
      },
      {
        label: PRICE_OVERRIDE_SORT_OPTIONS_MAP[PriceOverrideSort.ProgramSession],
        command: () => {
          updateSortBy(PriceOverrideSort.ProgramSession);
        },
      },
      {
        label: PRICE_OVERRIDE_SORT_OPTIONS_MAP[PriceOverrideSort.RequestedDate],
        command: () => {
          updateSortBy(PriceOverrideSort.RequestedDate);
        },
      },
      {
        label: PRICE_OVERRIDE_SORT_OPTIONS_MAP[PriceOverrideSort.StudentName],
        command: () => {
          updateSortBy(PriceOverrideSort.StudentName);
        },
      },
      {
        label: PRICE_OVERRIDE_SORT_OPTIONS_MAP[PriceOverrideSort.DecisionDate],
        command: () => {
          updateSortBy(PriceOverrideSort.DecisionDate);
        },
      },
    ],
  },
]);

const sortByLabel = computed(() => PRICE_OVERRIDE_SORT_OPTIONS_MAP[sortBy.value]);
const orderLabel = computed(() => (sortOrder.value === SortOrder.Asc ? "Ascending" : "Descending"));

const toggle = (event) => {
  menu.value.toggle(event);
};

const changeSortOrder = async () => {
  const newSortorder = sortOrder.value === SortOrder.Asc ? SortOrder.Desc : SortOrder.Asc;
  await updateSortOrder(newSortorder);
};
</script>

<template>
  <div class="card flex justify-content-center">
    <Button @click="changeSortOrder" @mouseover="isExpanded = true" @mouseleave="isExpanded = false" outlined :class="['!rounded-full', 'mr-2', '!h-8', 'bg-white', '!border-gray-300', {'!w-[38px] !border-cyan-200': !isExpanded}]">
      <div class="flex align-center justify-center">
        <span class="ml-2 leading-8 text-cyan-200" v-show="isExpanded">{{ orderLabel }}</span>
        <SimpleSortIcon :class="[{'rotate-180': sortOrder !== SortOrder.Asc}]"/>
      </div>
    </Button>
    <Button class="w-[260px] !h-8 !border-gray-300 !rounded-full mx-auto !bg-white" :pt="filtersPresets.sortByButton" type="button" icon="pi pi-ellipsis-v" outlined @click="toggle" aria-haspopup="true" aria-controls="overlay_menu">
      <template #default>
        <div class="flex items-center justify-center capitalized text-sm font-semibold font-[montserrat] text-university-primary">
          <div>Sort By:</div>
          <div class="font-normal pl-2">{{sortByLabel}}</div>
          <div class="material-symbols-outlined text-surface-700">keyboard_arrow_down</div>
        </div>
      </template>
    </Button>
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" :pt="filtersPresets.sortByMenu" />
  </div>
</template>

<style scoped>

</style>
